import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ToastProvider } from './components/ErrorToast';
import { makeQueryClient } from './lib/query-client';
import { RoleProvider } from './lib/role';
import './index.css';

const queryClient = makeQueryClient();

// biome-ignore lint/style/noNonNullAssertion: корневой элемент есть в index.html
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RoleProvider>
        <ToastProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ToastProvider>
      </RoleProvider>
    </QueryClientProvider>
  </StrictMode>,
);
